import { render } from "./PWAUpdateNotification.vue?vue&type=template&id=470d7778"
import script from "./PWAUpdateNotification.vue?vue&type=script&lang=js"
export * from "./PWAUpdateNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__